


































import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';
import { QuestionnaireGatewayModel, QuestionnaireModel } from '@/core/models';
import { InputRadioGatewayCpt } from '@/core/components';
import { Gateway } from '@/core/constants';

@Component({
  components: {
    InputRadioGatewayCpt,
  },
})
export default class QuestionnaireGatewayCpt extends AppVue {
  @Prop() index: Gateway;
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) showComment: boolean;

  @Watch('index')
  onIndexChange() {
    this.loadModel();
  }

  @Watch('model', { deep: true })
  onModelChange() {
    this.loadModel();
  }

  loading = false;

  options = [
    {
      id: 25,
      text: '< 25 %',
    },
    {
      id: 50,
      text: '< 50 %',
    },
    {
      id: 75,
      text: '< 75 %',
    },
    {
      id: 100,
      text: '≤ 100 %',
    },
  ];

  questionMapping = {
    [Gateway.Workshop1]: {
      questions: [
        {
          identifier: 'vision_mission_alignment',
          text: 'The management team agrees on our long-term vision, mission, values and priorities',
          sortOrder: 1,
        },
        {
          identifier: 'top_strategic_objectives',
          text:
            'The management team has agreed the top three strategic objectives we need to achieve in the next 12-18 months',
          sortOrder: 2,
        },
        {
          identifier: 'objectives_strategic_alignment',
          text:
            'These objectives align with our overall strategic intent and long-term vision (vs objectives respond to an imminent or short-term challenge)',
          sortOrder: 3,
        },
        {
          identifier: 'kpi_success_metrics',
          text: 'We have key performance indicators (KPIs) in place to measure success',
          sortOrder: 4,
        },
        {
          identifier: 'core_capabilities_identified',
          text: 'We have identified the core capabilities required to achieve our Strategic Objectives',
          sortOrder: 5,
        },
        {
          identifier: 'obstacles_identified',
          text: 'We have identified the biggest obstacles preventing us from achieving these objectives',
          sortOrder: 6,
        },
        {
          identifier: 'emerging_opportunities_threats',
          text: 'We have identified emerging opportunities or threats that may require a shift in strategic focus',
          sortOrder: 7,
        },
        {
          identifier: 'management_department_alignment',
          text: 'The senior management and key departments are aligned in their understanding of these priorities',
          sortOrder: 8,
        },
        {
          identifier: 'long_term_staffing_plan',
          text:
            'We have a clearly defined long-term staffing and skills plan that aligns with our strategic objectives',
          sortOrder: 9,
        },
      ],
    },
    [Gateway.Workshop2]: {
      questions: [
        {
          identifier: 'strategic_goals_identified',
          text: 'Strategic goals, priorities, core capabilities identified',
          sortOrder: 1,
        },
        {
          identifier: 'smt_engagement_agreement',
          text: 'SMT engagement and agreement on 1',
          sortOrder: 2,
        },
        {
          identifier: 'decision_makers_ws2',
          text: 'Appropriate decision makers available to attend WS2',
          sortOrder: 3,
        },
      ],
    },
    [Gateway.FollowUp]: {
      questions: [
        {
          identifier: 'strategic_goals_feasibility',
          text: 'Strategic goals, priorities, core capabilities clear, suitable, acceptable and feasible',
          sortOrder: 1,
        },
        {
          identifier: 'skills_identified_from_goals',
          text: 'Identified skills clearly arise from 1',
          sortOrder: 2,
        },
        {
          identifier: 'company_skills_plan_agreed',
          text: 'Company skills plan agreed with wider management team',
          sortOrder: 3,
        },
        {
          identifier: 'skills_gap_estimation',
          text: 'Skills gap: estimated current/future requirements clearly arise from 1 & 2',
          sortOrder: 4,
        },
        {
          identifier: 'build_buy_feasibility',
          text: 'Build, buy etc appropriate and feasible (given 1-3)',
          sortOrder: 5,
        },
        {
          identifier: 'rsm_engagement_planned',
          text: 'Engaged with/planned engagement with RSM',
          sortOrder: 6,
        },
      ],
    },
  };

  get gateway() {
    return Gateway;
  }

  get title() {
    switch (this.index) {
      case Gateway.Workshop1:
        return 'Pre-Workshop Diagnostic Questionnaire';
      case Gateway.Workshop2:
        return 'Progression to Workshop 2';
      case Gateway.FollowUp:
        return 'Readiness for 1-1';
      default:
        return '';
    }
  }

  get gateways() {
    return this.model.gateways.filter(gateway => gateway.gatewayId === this.index);
  }

  private getQuestionByIdentifier(identifier: string) {
    const question = _.find(this.questionMapping[this.index].questions, { identifier });
    return question ? question.text : '';
  }

  private getGatewayInitialIndex(gateway: QuestionnaireGatewayModel) {
    return this.model.gateways.indexOf(gateway);
  }

  private loadModel() {
    if (!this.model) {
      return;
    }
    this.loading = true;
    try {
      for (const question of this.questionMapping[this.index].questions.sort((a, b) => a.sortOrder - b.sortOrder)) {
        if (!_.some(this.model.gateways, { gatewayId: this.index, identifier: question.identifier })) {
          this.model.gateways.push(
            new QuestionnaireGatewayModel({ gatewayId: this.index, identifier: question.identifier }),
          );
        }
      }
    } finally {
      this.loading = false;
    }
  }

  created() {
    this.loadModel();
  }
}
